import { Unionize } from 'utilitys/helpers/TsGeneral';
import { StateCreator, create } from 'zustand';

import { Details } from 'components/common/UploadFileModal/components/programLibrary.types';

interface Props {
    modalShow: boolean;
    details: Details | null;
    isUploading: boolean;
    showWarningModal: boolean;
    update: (value: Unionize<Omit<Props, 'update'>>) => void;
}

const state: StateCreator<Props> = (set) => ({
    modalShow: false,
    details: null,
    isUploading: false,
    showWarningModal: false,
    update: (value) => set({ ...value }),
});

export const useProgramLibraryStore = create(state);
